// One place for Sorat Web and Sorat App.
// Backend game types: web = "so", app = "so_app".
// Backend socket names: web = "so-...", app = "so-app-...".

export const SORAT_CHANNELS = {
    web: {
        platform: "web",
        label: "Web",
        gameType: "so",
        socketPrefix: "so"
    },
    app: {
        platform: "app",
        label: "App",
        gameType: "so_app",
        socketPrefix: "so-app"
    }
};

export const getSoratChannel = (platform) => SORAT_CHANNELS[platform] || SORAT_CHANNELS.web;

export const soratSocketEvents = (platform) => {
    const prefix = getSoratChannel(platform).socketPrefix;
    return {
        TIMER: `${prefix}-timerUpdate`,
        HISTORY: `${prefix}-lastTenWinners`,
        GET_USER_LAST_BID: `${prefix}-getUserLastBid`,
        USER_LAST_BID_RESPONSE: `${prefix}-userLastBidResponse`,
        BID_UPDATE: `${prefix}-bidUpdate`,
        MANUAL_WINDOW: `${prefix}-manualWinnerWindow`,
        NEW_ROUND: `${prefix}-newRound`,
        ROUND_COMPLETED: `${prefix}-roundCompleted`,
        PLACE_BID: `${prefix}-placeBid`,
        HISTORY_FALLBACK: `${prefix}-lastTenWinner`,
        PLAY_SPIN: `${prefix}-playSpin`
    };
};
